import { render } from "./ListeBonCommandeFournisseurPage.vue?vue&type=template&id=51b6f586&ts=true"
import script from "./ListeBonCommandeFournisseurPage.vue?vue&type=script&lang=ts"
export * from "./ListeBonCommandeFournisseurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__